import { useInventoryTransfersPage } from "./hooks/useInventoryTransfersPage";
import { useTransferDialogPermissions } from "./hooks/useTransferDialogPermissions";
import { useAddAdditionalLayoutButton } from "../../../common/infrastructure/hooks/useAddAdditionalLayoutButton";
import { InventoryTransferEmptyState } from "./components/InventoryTransferEmptyState";
import { InventoryTransferListItem } from "./components/InventoryTransferListItem";
import { InventoryTransferDialog } from "./components/InventoryTransferDialog";
import { RenderWhen } from "../../../common/infrastructure/components/RenderWhen";
import styles from "./InventoryTransfersPage.module.scss";
import { IconType } from "../../../common/icons/Icon";
import { OnboardingItemKey } from "../../../common/enums";
import { usePageGuide } from "../../onboarding/hooks/usePageGuide";

const SKELETON_COUNT = 4;

const TransfersSkeleton = () => (
  <div className={styles.skeleton_list}>
    {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
      <div key={i} className={styles.skeleton_row}>
        <div className={styles.skeleton_top}>
          <span className={styles.skeleton_number} />
          <span className={styles.skeleton_badge} />
        </div>
        <span className={styles.skeleton_date} />
        <div className={styles.skeleton_pills}>
          <span className={styles.skeleton_pill} />
          <span className={styles.skeleton_pill} />
        </div>
      </div>
    ))}
  </div>
);

export const InventoryTransfersPage = () => {
  const {
    transfers,
    isLoading,
    isDialogOpen,
    editingTransferId,
    prefillLines,
    openCreate,
    openEdit,
    closeDialog,
    requestDelete,
  } = useInventoryTransfersPage();

  const permissions = useTransferDialogPermissions();

  usePageGuide(OnboardingItemKey.InventoryTransfersGuide);

  useAddAdditionalLayoutButton({
    iconType: IconType.PlusIcon,
    buttonOnClick: permissions.canCreate ? openCreate : undefined,
    validator: permissions.canCreate,
  });

  const hasAny = transfers.length > 0;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>Доставки</h1>
      </div>

      <RenderWhen condition={isLoading}>
        <TransfersSkeleton />
      </RenderWhen>

      <RenderWhen condition={!isLoading && !hasAny}>
        <InventoryTransferEmptyState
          canCreate={permissions.canCreate}
          onCreate={openCreate}
        />
      </RenderWhen>

      <RenderWhen condition={!isLoading && hasAny}>
        <div className={styles.list}>
          {transfers.map((transfer) => (
            <InventoryTransferListItem
              key={transfer.id}
              transfer={transfer}
              canDelete={permissions.canDelete}
              canEdit={permissions.canEditStatus(transfer.status)}
              onEdit={() => openEdit(transfer.id)}
              onToggleDelete={() => requestDelete(transfer)}
            />
          ))}
        </div>
      </RenderWhen>

      <InventoryTransferDialog
        isOpen={isDialogOpen}
        editingTransferId={editingTransferId}
        initialLines={prefillLines}
        onClose={closeDialog}
      />
    </div>
  );
};
